export default __webpack_public_path__ + "static/img/networkingBG.b53db110f8149c8e87e9f43f7fbccdd1.png";